/**
 * @generated SignedSource<<f62afe791476bf6c90785309612870a0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ViewPageCommentsPanelPermission_content$data = {
  readonly id: string | null;
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly " $fragmentType": "ViewPageCommentsPanelPermission_content";
};
export type ViewPageCommentsPanelPermission_content$key = {
  readonly " $data"?: ViewPageCommentsPanelPermission_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewPageCommentsPanelPermission_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ViewPageCommentsPanelPermission_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    }
  ],
  "type": "Content"
};

(node as any).hash = "66b214781462a01030925ab4bd0a23d3";

export default node;
